import { jsxs as m, jsx as a } from "react/jsx-runtime";
import d from "react";
import r, { css as e } from "styled-components";
import { m as s } from "./breakpoints.907eaecd.js";
import { R as g, H as l } from "./Heading.2a0f9b41.js";
import { R as v, B as f } from "./index.b09c00db.js";
import { RangoProgressLine as x } from "../es/ProgressLine.js";
const h = r.div.withConfig({
  displayName: "NavBar",
  componentId: "sc-aqf8re-0"
})(["display:flex;justify-content:space-between;align-items:center;position:relative;padding:0 var(--spacing-3x) 0 var(--spacing-5x);background-color:var(--elements-bg-color-01);position:relative;height:var(--size-12x);", ""], s.sm(e(["padding:0 var(--spacing-1x) 0 var(--spacing-3x);"]))), R = r.div.withConfig({
  displayName: "Progress",
  componentId: "sc-aqf8re-1"
})(["position:absolute;bottom:0;width:calc(100% - var(--spacing-5x) - var(--spacing-3x) - var(--size-2x));", ""], s.sm(e(["width:calc(100% - var(--spacing-3x) - var(--spacing-1x) - var(--size-2x));"]))), C = d.forwardRef(({
  heading: i,
  progress: o,
  buttonCloseProps: n,
  onClose: t,
  ...c
}, p) => /* @__PURE__ */ m(h, { ...c, ref: p, children: [
  /* @__PURE__ */ a(g, { ...i, size: l.XS, children: i.children }),
  /* @__PURE__ */ a(v, { size: f.LG, icon: "CloseLine", onClick: t, "aria-label": "Fechar", ...n }),
  o && /* @__PURE__ */ a(R, { children: /* @__PURE__ */ a(x, { ...o }) })
] }));
export {
  C as R
};
